import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import fr from "./locales/fr.json";
import pt from "./locales/pt.json";
import ar from "./locales/ar.json";
import my from "./locales/my.json";
import vi from "./locales/vi.json";
import es from "./locales/es.json";
import fa from "./locales/fa.json";
import th from "./locales/th.json";
import bn from "./locales/bn.json";
import de from "./locales/de.json";
import hi from "./locales/hi.json";
import ko from "./locales/ko.json";
import km from "./locales/km.json";
import it from "./locales/it.json";
import ja from "./locales/ja.json";
import sw from "./locales/sw.json";
import id from "./locales/id.json";
import ru from "./locales/ru.json";
import fil from "./locales/fil.json";
import tr from "./locales/tr.json";

const SUPPORTED_LANGUAGES = [
  "en", "fr", "pt", "ar", "my", "vi", "es", "fa", "th", "bn",
  "de", "hi", "ko", "km", "it", "ja", "sw", "id", "ru", "fil", "tr",
];

i18n.use(initReactI18next).init({
  resources: {
    en:  { translation: en },
    fr:  { translation: fr },
    pt:  { translation: pt },
    ar:  { translation: ar },
    my:  { translation: my },
    vi:  { translation: vi },
    es:  { translation: es },
    fa:  { translation: fa },
    th:  { translation: th },
    bn:  { translation: bn },
    de:  { translation: de },
    hi:  { translation: hi },
    ko:  { translation: ko },
    km:  { translation: km },
    it:  { translation: it },
    ja:  { translation: ja },
    sw:  { translation: sw },
    id:  { translation: id },
    ru:  { translation: ru },
    fil: { translation: fil },
    tr:  { translation: tr },
  },
  lng: "en",
  fallbackLng: "en",
  supportedLngs: SUPPORTED_LANGUAGES,
  interpolation: { escapeValue: false },
});

export { SUPPORTED_LANGUAGES };
export default i18n;
